import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 13 10",
	fill: "none",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.1319 0.851562L6.21086 8.43318L1.28988 0.851562L11.1319 0.851562Z" })
});
export default SvgTriangle;
